export const getApiVersion = () => 'v1';

export const getHeaderInfo = (responseAPI) => {
  const pageCount = responseAPI.headers['x-paging-pagecount']
    ? parseInt(responseAPI.headers['x-paging-pagecount'], 10)
    : null;
  const pageNumber = responseAPI.headers['x-paging-pagenumber']
    ? parseInt(responseAPI.headers['x-paging-pagenumber'], 10)
    : null;
  const pageSize = responseAPI.headers['x-paging-pagesize']
    ? parseInt(responseAPI.headers['x-paging-pagesize'], 10)
    : null;
  const totalRecordCount = responseAPI.headers['x-paging-totalrecordcount']
    ? parseInt(responseAPI.headers['x-paging-totalrecordcount'], 10)
    : null;
  return { pageCount, pageNumber, pageSize, totalRecordCount };
};

export const download = (fileName, exportFunction) => {
  exportFunction
    .then((res) => {
      try {
        const blob = new Blob([res.data], { type: 'application/excel' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName.includes('.xlsx')
          ? fileName
          : `${fileName}.xlsx`;
        link.click();
      } catch (e) {
         
        console.log(e);
      }
    })
    .catch((err) => {
       
      console.log(err);
    });
};
